import { useEffect, useMemo, useReducer } from 'react';
import { translate } from '@utils/i18n';
import { saveCacheToLocalStorage, loadCacheFromLocalStorage } from '../../../helpers/localStorage';
import { INITIAL_KIT_ORDER_FILTERS, KIT_ORDERS_CACHE_KEY } from '../constants';
import { kitOrdersReducer, kitOrderActionTypes } from './kitOrdersReducer';
import { useKitOrdersQuery } from './useKitOrdersQuery';
const useFilteredKitOrders = () => {
    const CACHE_KEY = useMemo(() => KIT_ORDERS_CACHE_KEY, []);
    const getInitialState = () => {
        const cache = loadCacheFromLocalStorage(CACHE_KEY);
        return {
            data: [],
            search: '',
            totalCount: 0,
            page: (cache === null || cache === void 0 ? void 0 : cache.page) || { skip: 0, take: 25 },
            sort: (cache === null || cache === void 0 ? void 0 : cache.sort) || [],
            filters: (cache === null || cache === void 0 ? void 0 : cache.filters) || INITIAL_KIT_ORDER_FILTERS
        };
    };
    const [state, dispatch] = useReducer(kitOrdersReducer, null, getInitialState);
    const { page, sort, filters, search } = state;
    const { data: queryData, isLoading, error } = useKitOrdersQuery({ page, sort, filters, search });
    useEffect(() => {
        if (queryData)
            dispatch({ type: kitOrderActionTypes.DATA_LOADED, data: queryData });
    }, [queryData]);
    useEffect(() => {
        saveCacheToLocalStorage(CACHE_KEY, { page, sort, filters });
    }, [CACHE_KEY, page, sort, filters]);
    const onResetCache = () => {
        // eslint-disable-next-line no-alert
        if (!window.confirm(translate('are_you_sure', { namespace: 'generic' })))
            return;
        localStorage.removeItem(CACHE_KEY);
        window.location.reload();
    };
    return {
        data: state.data,
        totalCount: state.totalCount,
        isLoading,
        error: error || null,
        page,
        sort,
        filters,
        search,
        dispatch,
        onResetCache
    };
};
export default useFilteredKitOrders;
